/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { MIN_START_TIME_UTC } from 'cio/utils/journey-metrics';

interface AnalysisPageJourneyMetricsTimeWarningTooltipArgs {
  iconClass: string;
}

export default class AnalysisPageJourneyMetricsTimeWarningTooltip extends Component<AnalysisPageJourneyMetricsTimeWarningTooltipArgs> {
  journeyMetricsReleaseDate = MIN_START_TIME_UTC;
}
